import { useTranslation } from "react-i18next";
import "./Footer.css";
import { FooterProps } from "../../types/FooterProps";

export default function Footer({
    showCookieConsent,
    onClickCookiePolicy
}: Readonly<FooterProps>) {
    const { t } = useTranslation("common");
    const currentYear = new Date().getFullYear();

    return (
        <footer className={`portal-footer`} data-testid="footer">
            <div className="footer-container">
                <div className="flex-wrap" data-testid="copyright">{`${t(
                    "footer.copyright",
                    {
                        currentYear: currentYear
                    }
                )}`}</div>
                <div className="md:flex hidden">|</div>
                <div>
                    <a
                        href="https://www.idwalmarine.com/iso"
                        target="_blank"
                        data-testid="iso"
                    >{`${t("footer.iso")}`}</a>
                </div>
                <div className="md:flex hidden">|</div>
                <div className="flex gap-3" data-testid="terms">
                    <a
                        href="https://www.idwalmarine.com/terms-and-conditions/terms-of-use"
                        target="_blank"
                    >
                        {`${t("footer.terms")}`}
                    </a>
                </div>
                <div className="md:flex hidden">|</div>
                <div>
                    <a
                        href="https://www.idwalmarine.com/privacy-policy"
                        target="_blank"
                        data-testid="privacy-policy"
                    >
                        {`${t("footer.privacy")}`}
                    </a>
                </div>
                {showCookieConsent && (
                    <>
                        <div>|</div>
                        <div className="flex gap-3">
                            <a
                                onClick={onClickCookiePolicy}
                                target="_blank"
                                style={{ textDecoration: "underline", cursor: "pointer" }}
                                data-testid="cookie-policy"
                            >
                                {`${t("footer.cookie")}`}
                            </a>
                        </div>
                    </>
                )}
            </div>
        </footer>
    );
}